import React from 'react';
import { Alert } from '@planne-software/uni/Alert';
import { IconAlertTriangle } from '@planne-software/uni/icons';

import { useTranslate } from '@src/core/hooks';

export const EmailNotFoundAlert = () => {
  const { i18n } = useTranslate();

  return (
    <Alert
      data-testid='signup-email-not-found-alert'
      severity='warning'
      startIcon={<IconAlertTriangle size={20} aria-hidden />}
      title={i18n('checkout_auth_signup_email_not_found_title')}
      subTitle={i18n('checkout_auth_signup_email_not_found_message')}
    />
  );
};

export default EmailNotFoundAlert;
